import { Component, inject, OnInit, signal, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ProductService } from '../../../../services/product/product.service';
import { SubProductsFilter } from './sub-products-filter/sub-products-filter';
import { SubProductsList } from './sub-products-list/sub-products-list';
import { EmptyData } from '../../../../utils/empty-data/empty-data';
import { ErrorData } from '../../../../utils/error-data/error-data';
import { Loading } from '../../../../utils/loading/loading';
import { SubProductFilters, SubProductListItem } from '../../../../pages/admin-dashboard/products/product.model';

@Component({
  selector: 'app-product-sub-products',
  standalone: true,
  imports: [
    CommonModule,
    SubProductsFilter,
    SubProductsList,
    RouterLink,
    EmptyData,
    ErrorData,
    Loading,
  ],
  templateUrl: './product-sub-products.html',
  styleUrl: './product-sub-products.scss',
})
export class ProductSubProducts implements OnInit {
  private subProductService = inject(ProductService);
  productId = input.required<number>();

  subProducts = signal<SubProductListItem[]>([]);
  totalItems = signal(0);
  loading = signal(false);
  error = signal(false);

  filters = signal<SubProductFilters>({
    subProductTitle: '',
    createdOnFrom: '',
    createdOnTo: '',
    isActive: '',
    orderBy: 'LAST_MODIFICATION_DATE',
    orderDir: 'DESC',
    pageNum: 0,
    pageSize: 25,
  });

  ngOnInit() {
    this.loadSubProducts();
  }

  loadSubProducts() {
    this.loading.set(true);
    this.error.set(false);
    this.subProductService
      .getSubProducts(this.productId(), this.filters())
      .subscribe({
        next: (res) => {
          this.subProducts.set(res.list);
          this.totalItems.set(res.total);
          this.loading.set(false);
        },
        error: () => {
          this.loading.set(false);
          this.error.set(true);
        },
      });
  }

  applyFilters() {
    this.filters.update((f) => ({ ...f, pageNum: 0 }));
    this.loadSubProducts();
  }

  resetFilters() {
    this.filters.set({
      subProductTitle: '',
      createdOnFrom: '',
      createdOnTo: '',
      isActive: '',
      orderBy: 'LAST_MODIFICATION_DATE',
      orderDir: 'DESC',
      pageNum: 0,
      pageSize: 25,
    });
    this.loadSubProducts();
  }

  // The pagination component is 1-based, the API is 0-based
  handlePageChange(event: { page: number; size: number }) {
    this.filters.update((f) => ({
      ...f,
      pageNum: event.page - 1,
      pageSize: event.size,
    }));
    this.loadSubProducts();
  }

  toggleSort() {
    const newDir = this.filters().orderDir === 'ASC' ? 'DESC' : 'ASC';
    this.filters.update((f) => ({ ...f, orderDir: newDir }));
    this.loadSubProducts();
  }
}
